import { Stack } from "expo-router";
import { useUnistyles } from "react-native-unistyles";

import PageLayout from "$src/core/components/templates/PageLayout";
import LoadingPage from "$src/core/pages/LoadingPage/LoadingPage";
import useMenuQuery from "$src/core/queries/use-menu-query";

const Layout: React.FC = () => {
  const { theme } = useUnistyles();
  const { data: menu } = useMenuQuery();

  if (!menu) {
    return (
      <PageLayout>
        <LoadingPage />
      </PageLayout>
    );
  }

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: theme.colors.backgroundDefault },
      }}
    >
      <Stack.Screen name="(tabs)" options={{ headerShown: false }} />
      <Stack.Screen name="[type]/[id]" options={{ headerShown: false }} />
      <Stack.Screen name="[type]/[id]/play" options={{ headerShown: false }} />
    </Stack>
  );
};
export default Layout;
